function injectStyle (ssrContext) {
  require("!!../../../../node_modules/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-10b3ea4b\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=styles&index=0!./interval.vue")
}
var Component = require("!../../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./interval.vue"),
  /* template */
  require("!!../../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-10b3ea4b\",\"hasScoped\":false}!../../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./interval.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/indexRouters/goods/interval.vue
// module id = 858
// module chunks = 1